<template>
  <div class="breadcrumb-block">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item, index) in routes" :key="index" :to="{ path: item.path }">{{item.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
/**
 * @description Breadcrumb面包屑
 */
export default {
  name: 'Breadcrumb',
  props: {
    // // 用户信息
    // userInfo: {
    //   type: Object,
    // }
  },
  data() {
    return {
      routes: [],
    }
  },
  // 监听url的变动
  watch: {
    $route() {
      this.routes = this.$route.matched
    }
  },
  created() {
    this.routes = this.$route.matched;
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb-block {
  border-bottom: 2px solid $colorNormal;

  /deep/.el-breadcrumb {
    width: 1285px;
    margin: 0 auto;
    height: 50px;
    line-height: 52px;
  }

}
</style>


